// extracted by mini-css-extract-plugin
export default {"MessageTop":"_MessageTop--Cgk9n","SelectedFile":"_SelectedFile--BbAb3","MessageBottom":"_MessageBottom--i7qTT","ImageRecommendation":"_ImageRecommendation--_viP1"};